import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";

const QUOTES = {
  "featured-1":
    "I have made several trek with Sherpatrekker! Five! Because I enjoyed so much the first one with sherpatrekker that I would come again! Nepal is an enchanting country and all the trek I made with sherpatrekker has been amazing! Pasang Sherpa the guide, is a true professional! His team too! Only good surprise with them!",
  1: "Thank you Sherpa Trekker for organizing this trip. It was a pleasure to meet you: Sanu, Pemba, Pasang's family, Fireman, Mama from the Garden Inn hotel, Maya, Khrishna and all the others. Thank you all for your smiles, your sharing, your joy, your welcome. We had a very nice trip among you. Thank you for all",
  2: "Pasang Sherpa is a very good trekking guide, who knows his business. Nothing to complain. I felt safe and well-protected with him during the entire trek. He has great knowledge of his country. He told me what to eat and what not and why. He showed me things that I would never seen without him. I am more than satisfied with his great service. Anytime again with him. It was very useful to get a big travel bag and map!",
  3: "I booked three treks with 'Sherpatrekker': the first was the Ghorepani Poonhill trek, followed by a climb of Pikey Peak where I experienced the sunrise with a view of Everest, and finally a trek in the Langtang Valley. Along with his meticulous planning and sense of responsibility, the good humour of Pasang and his team ensured an unforgettable trek.",
  4: "Sherpatrekker is an excellent choice. It takes every request into account; the boss and Guide Pasang Sherpa is a very friendly and caring person. He organises the treks to perfection, and changes are no problem at all. You're treated like royalty, and he treats his team exceptionally well too. If a problem arises, we'll look for the best possible solution and act on it; the price includes everything from full board to a hot shower or a beer in the evening, if possible. The trekking route can be tailored to your preferences; it's definitely worth hiking through this beautiful mountainous region with Pasang and his team. Whether in spring or autumn – each season has its own charm. A trekking with Pasang and his people is an enriching and unforgettable experience. It provides an insight into Nepalese culture and the simple way of life of the mountain people. 🌺🪷💖 Have a wonderful day",
};

const HIGHLIGHTS = {
  "featured-1": [
    "Completed 5 incredible treks across Nepal",
    "Built lasting friendship with Pasang Sherpa and team",
    "Discovered hidden trails and local communities",
    "Felt safe and well-supported every step",
    "Fell in love with Nepal's enchanting beauty",
  ],
  1: [
    "Warm welcome from Pasang's family",
    "Memorable encounters with local community",
    "Authentic cultural sharing and smiles",
    "Well-organized Langtang Valley experience",
  ],
  2: [
    "Expert guidance on food and health",
    "Hidden gems off the beaten path",
    "Complete safety and protection",
    "Provided with travel bag and map",
    "Personalized attention throughout",
  ],
  3: [
    "Completed 3 unique treks across Nepal",
    "Witnessed sunrise over Everest from Pikey Peak",
    "Experienced Pasang's meticulous planning",
    "Enjoyed good humour and team spirit throughout",
  ],
  4: [
    "Every request taken into account",
    "Treks organised to perfection with flexible changes",
    "Treated like royalty with everything included",
    "Insight into Nepalese culture and mountain life",
  ],
};

const StoryDetail = () => {
  const { storyId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const story = location.state?.story;

  if (!story) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <p className="text-text-secondary mb-4">Story not found</p>
          <Button variant="default" onClick={() => navigate("/traveler-stories-hub")}>
            Back to Stories
          </Button>
        </div>
      </div>
    );
  }

  const quote = QUOTES[story.id] || story.excerpt;
  const highlights = HIGHLIGHTS[story.id] || [];

  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* Hero */}
      <section className="relative pt-28 lg:pt-32">
        <div className="relative h-[40vh] sm:h-[50vh] min-h-[280px] sm:min-h-[400px] overflow-hidden">
          <img
            src={story.featuredImage}
            alt={story.title}
            className="w-full h-full object-cover"
            onError={(e) => { e.target.src = "/assets/images/no_image.png"; }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
          <button
            onClick={() => navigate("/traveler-stories-hub")}
            className="absolute top-6 left-6 flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 text-white px-4 py-2 rounded-full text-sm hover:bg-white/25 transition-colors"
          >
            <Icon name="ArrowLeft" size={16} />
            All Stories
          </button>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-20 relative z-10">
          <div className="bg-card rounded-2xl shadow-xl p-8 lg:p-10">
            {/* Traveler */}
            <div className="flex items-center gap-4 mb-6">
              <img
                src={story.traveler?.avatar}
                alt={story.traveler?.name}
                className="w-16 h-16 rounded-full object-cover ring-4 ring-primary/20"
                onError={(e) => { e.target.src = "/assets/images/no_image.png"; }}
              />
              <div>
                <h1 className="text-2xl lg:text-3xl font-headline text-foreground">
                  {story.traveler?.name}
                </h1>
                <p className="text-text-secondary">
                  {story.traveler?.location}
                  {story.traveler?.profession ? ` · ${story.traveler.profession}` : ""}
                </p>
                <div className="flex items-center gap-4 mt-1 text-sm text-text-secondary">
                  <span className="flex items-center gap-1">
                    <Icon name="MapPin" size={14} className="text-primary" />
                    {story.trek}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} className="text-primary" />
                    {story.trekDate}
                  </span>
                </div>
              </div>
            </div>

            {/* Title */}
            <h2 className="text-xl lg:text-2xl font-headline text-foreground mb-6 leading-snug">
              {story.title}
            </h2>

            {/* Rating */}
            <div className="flex items-center gap-1 mb-6">
              {[...Array(5)].map((_, i) => (
                <Icon
                  key={i}
                  name="Star"
                  size={18}
                  className={i < story.rating ? "text-yellow-400 fill-current" : "text-gray-300"}
                />
              ))}
              <span className="ml-2 text-sm text-text-secondary">{story.rating}/5</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-3 gap-10">
          {/* Main */}
          <div className="lg:col-span-2 space-y-8">
            {/* Story excerpt */}
            <section>
              <h3 className="text-lg font-headline text-foreground mb-3 flex items-center gap-2">
                <Icon name="BookOpen" size={18} className="text-primary" />
                Their Journey
              </h3>
              <p className="text-text-secondary leading-relaxed text-base">
                {story.excerpt}
              </p>
            </section>

            {/* Full testimonial */}
            <section className="bg-muted/40 rounded-2xl p-6 lg:p-8 border border-border">
              <div className="flex items-start gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Icon
                    key={i}
                    name="Star"
                    size={16}
                    className={i < story.rating ? "text-yellow-400 fill-current" : "text-gray-300"}
                  />
                ))}
              </div>
              <p className="text-foreground text-lg leading-relaxed italic font-medium">
                "{quote}"
              </p>
              <div className="mt-4 pt-4 border-t border-border flex items-center gap-3">
                <img
                  src={story.traveler?.avatar}
                  alt={story.traveler?.name}
                  className="w-10 h-10 rounded-full object-cover"
                  onError={(e) => { e.target.src = "/assets/images/no_image.png"; }}
                />
                <div>
                  <p className="font-semibold text-foreground text-sm">{story.traveler?.name}</p>
                  <p className="text-xs text-text-secondary">{story.traveler?.location}</p>
                </div>
              </div>
            </section>

            {/* Highlights */}
            {highlights.length > 0 && (
              <section>
                <h3 className="text-lg font-headline text-foreground mb-4 flex items-center gap-2">
                  <Icon name="Sparkles" size={18} className="text-primary" />
                  Experience Highlights
                </h3>
                <div className="grid sm:grid-cols-2 gap-3">
                  {highlights.map((h, i) => (
                    <div key={i} className="flex items-start gap-3 bg-white rounded-xl p-4 border border-border shadow-sm">
                      <span className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Icon name="Check" size={12} className="text-primary" />
                      </span>
                      <span className="text-sm text-gray-700">{h}</span>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Tags */}
            {story.tags?.length > 0 && (
              <section>
                <h3 className="text-lg font-headline text-foreground mb-3 flex items-center gap-2">
                  <Icon name="Tag" size={18} className="text-primary" />
                  Categories
                </h3>
                <div className="flex flex-wrap gap-2">
                  {story.tags.map((tag, i) => (
                    <span
                      key={i}
                      className="bg-primary/10 text-primary text-sm font-medium px-4 py-1.5 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </section>
            )}
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Trek info card */}
            <div className="bg-card rounded-2xl p-6 border border-border shadow-sm">
              <h4 className="font-headline text-foreground mb-4">Trek Details</h4>
              <div className="space-y-3 text-sm">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name="MapPin" size={16} className="text-primary" />
                  </div>
                  <div>
                    <p className="text-xs text-text-secondary">Destination</p>
                    <p className="font-medium text-foreground">{story.trek}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name="Calendar" size={16} className="text-primary" />
                  </div>
                  <div>
                    <p className="text-xs text-text-secondary">Date</p>
                    <p className="font-medium text-foreground">{story.trekDate}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name="Clock" size={16} className="text-primary" />
                  </div>
                  <div>
                    <p className="text-xs text-text-secondary">Read Time</p>
                    <p className="font-medium text-foreground">{story.readTime}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="bg-gradient-to-br from-primary to-himalayan-blue rounded-2xl p-6 text-white text-center">
              <Icon name="Mountain" size={32} className="mx-auto mb-3 opacity-80" />
              <h4 className="font-headline text-lg mb-2">Ready for Your Own Adventure?</h4>
              <p className="text-white/80 text-sm mb-5 leading-relaxed">
                Create your own transformation story in the Himalayas.
              </p>
              <Button
                variant="default"
                fullWidth
                className="bg-white text-primary hover:bg-white/90 font-semibold"
                onClick={() => navigate("/booking-consultation-center")}
              >
                Book Your Trek
              </Button>
            </div>

            {/* Back link */}
            <button
              onClick={() => navigate("/traveler-stories-hub")}
              className="w-full flex items-center justify-center gap-2 py-3 text-text-secondary hover:text-primary transition-colors text-sm font-medium"
            >
              <Icon name="ArrowLeft" size={16} />
              Browse All Stories
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-foreground text-white mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 mountain-gradient rounded-lg flex items-center justify-center mr-3 overflow-hidden">
                  <img src="/assets/images/logo.jpeg" alt="Sherpa Trekker Logo" />
                </div>
                <div>
                  <span className="text-xl font-headline block">Sherpa Trekker</span>
                  <span className="text-xs text-white/60">Where Adventure Meets Authenticity</span>
                </div>
              </div>
              <p className="text-white/70 mb-4 max-w-md text-sm leading-relaxed">
                Creating transformative Himalayan experiences that honour Sherpa culture while fostering genuine connections.
              </p>
            </div>
            <div>
              <h3 className="font-headline mb-4">Quick Links</h3>
              <ul className="space-y-2 text-white/70 text-sm">
                <li><a href="/trek-discovery-hub" className="hover:text-white">Discover Treks</a></li>
                <li><a href="/sherpa-guide-profiles" className="hover:text-white">Our Guides</a></li>
                <li><a href="/booking-consultation-center" className="hover:text-white">Book Consultation</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-headline mb-4">Contact</h3>
              <ul className="space-y-2 text-white/70 text-sm">
                <li className="flex items-center gap-2">
                  <Icon name="Phone" size={15} />
                  +977-9851157213
                </li>
                <li className="flex items-center gap-2">
                  <Icon name="Mail" size={15} />
                  imsherpatrekker@gmail.com
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/50 text-sm">
            <p>&copy; {new Date().getFullYear()} Sherpa Trekker. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default StoryDetail;
